import React from 'react';
import Input from '..';

const Password = React.memo(props => <Input component="password" capsLock={false} {...props} />);

export default Password;
